export default "__VITE_ASSET__BLScbQ_E__"